import { render, staticRenderFns } from "./CartSectionTitle.vue?vue&type=template&id=0031ade1&scoped=true&"
import script from "./CartSectionTitle.vue?vue&type=script&lang=js&"
export * from "./CartSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./CartSectionTitle.vue?vue&type=style&index=0&id=0031ade1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031ade1",
  null
  
)

export default component.exports